import { render, staticRenderFns } from "./SceneLandmarks.vue?vue&type=template&id=16909dd6"
import script from "./SceneLandmarks.vue?vue&type=script&lang=js"
export * from "./SceneLandmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports